import React from 'react';

import { IMAGES, COPY } from '../constants';
import styles from './fableticsUpgradeUpsell.scss';

// The upsell upgrade creative re-uses the upsell banner's MOBILE Power hero
// asset at both breakpoints — the card geometry is image-left in both viewports
// here, unlike the home banner which switches to a desktop strip.

const FableticsUpgradeUpsell = () => {
    return (
        <div
            className={styles.fableticsUpgradeUpsell}
            data-testid="fabletics.upgrade-creative.upsell.container"
        >
            <div className={styles.card} data-testid="fabletics.upgrade-creative.upsell.power-card">
                <div className={styles.cardImageWrap}>
                    <img src={IMAGES.powerHeroMobile} alt="" className={`${styles.cardImage} ${styles.cardImagePower}`} data-testid="fabletics.upgrade-creative.upsell.power-card.image" />
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.brandRow}>
                        <img src={IMAGES.powerIcon} alt="" className={styles.brandIcon} data-testid="fabletics.upgrade-creative.upsell.power-card.icon" />
                        <span className={styles.brandLabelPower} data-testid="fabletics.upgrade-creative.upsell.power-card.wordmark">POWER</span>
                    </div>
                    <p className={styles.cardCopy} data-testid="fabletics.upgrade-creative.upsell.power-card.copy">
                        {COPY.powerCard}
                    </p>
                </div>
            </div>

            <p
                className={styles.includedSubhead}
                data-testid="fabletics.upgrade-creative.upsell.included-subhead"
            >
                Included with the Annual Plan
            </p>

            <div className={styles.cardGroup}>
                <div className={styles.card} data-testid="fabletics.upgrade-creative.upsell.fabletics-card">
                    <div className={styles.cardImageWrap}>
                        <img
                            src={IMAGES.tennisWomen}
                            alt=""
                            className={`${styles.cardImage} ${styles.cardImageFabletics}`}
                            data-testid="fabletics.upgrade-creative.upsell.fabletics-card.image"
                        />
                    </div>
                    <div className={styles.cardBody}>
                        <img
                            src={IMAGES.fableticsLogo}
                            alt="Fabletics"
                            className={styles.brandLogoFabletics}
                            data-testid="fabletics.upgrade-creative.upsell.fabletics-card.logo"
                        />
                        <p className={styles.cardCopy} data-testid="fabletics.upgrade-creative.upsell.fabletics-card.copy">
                            {COPY.fableticsCard}
                        </p>
                    </div>
                </div>
                <p
                    className={styles.zipCaption}
                    data-testid="fabletics.upgrade-creative.upsell.zip-caption"
                >
                    USA billing ZIP required to access Fabletics.
                </p>
            </div>

            <div className={styles.card} data-testid="fabletics.upgrade-creative.upsell.gp-card">
                <div className={styles.cardImageWrap}>
                    <img
                        src={IMAGES.airport}
                        alt=""
                        className={`${styles.cardImage} ${styles.cardImageGp}`}
                        data-testid="fabletics.upgrade-creative.upsell.gp-card.image"
                    />
                </div>
                <div className={styles.cardBody}>
                    <img
                        src={IMAGES.gpLogo}
                        alt="Global Privileges"
                        className={styles.brandLogoGp}
                        data-testid="fabletics.upgrade-creative.upsell.gp-card.logo"
                    />
                    <p className={styles.cardCopy} data-testid="fabletics.upgrade-creative.upsell.gp-card.copy">
                        {COPY.gpCard}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FableticsUpgradeUpsell;
